import React, { memo } from 'react';
import { BaseEdge, EdgeLabelRenderer, EdgeProps, getSmoothStepPath } from 'reactflow';
import { IconButton, useTheme } from '@mui/material';
import { Plus } from 'lucide-react';

interface InsertButtonEdgeData {
  onInsert: (sourceId: string, targetId: string, mouseX: number, mouseY: number) => void;
}

const InsertButtonEdge: React.FC<EdgeProps<InsertButtonEdgeData>> = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style,
  markerEnd,
  data,
  source,
  target,
}) => {
  const theme = useTheme();
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
  });

  return (
    <>
      <BaseEdge id={id} path={edgePath} style={style} markerEnd={markerEnd} />
      <EdgeLabelRenderer>
        <div
          className="nodrag nopan"
          style={{
            position: 'absolute',
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            pointerEvents: 'all',
          }}
        >
          <IconButton
            size="small"
            onClick={e => {
              e.stopPropagation();
              data?.onInsert(source, target, e.clientX, e.clientY);
            }}
            sx={{
              width: 24,
              height: 24,
              backgroundColor: theme.palette.background.paper,
              border: `1.5px solid ${theme.palette.primary.main}`,
              '&:hover': {
                backgroundColor: theme.palette.primary.main,
                '& svg': {
                  color: theme.palette.primary.contrastText,
                },
              },
            }}
          >
            <Plus size={14} color={theme.palette.primary.main} />
          </IconButton>
        </div>
      </EdgeLabelRenderer>
    </>
  );
};

export default memo(InsertButtonEdge);
